import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

const baseStyles = {
  static: {
    position: 'fixed',
    height: '45px',
    zIndex: 3000,
    left: '25%',
    transform: 'translateX(-50%)',
    textAlign: 'center',
    transition: 'top 200ms ease',
    marginLeft: '15px !important',

    '@media print': {
      position: 'absolute',
    },
  },
  dynamic: ({ showEndButton }) => {
    return {
      marginTop: showEndButton ? 25 : -15,
    };
  },
};

const currentlyEmulatingButtonStyles = {
  ...baseStyles,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 20,
  borderBottomRightRadius: 20,
  padding: '45px 22px 7px',
  top: -25,
  fontSize: '12px !important',
  lineHeight: '12px !important',
  borderWidth: '2px !important',
  '.abyss-insert-element-after': {
    paddingLeft: '0px !important',
  },
};

const endEmualtionButtonStyles = {
  ...baseStyles,
  top: -85,
  fontSize: '13px !important',
  lineHeight: '13px !important',
  padding: '8px 23px !important',
  borderWidth: '2px !important',
  borderRadius: '24px !important',
  '.abyss-insert-element-after': {
    paddingLeft: '0px !important',
  },
};

const StyledContainer = styled('div', baseStyles);

const StyledIconSymbol = styled(IconSymbol, {
  fontSize: '20px !important',
});

export const TechnicalUserButton = ({ onClick }) => {
  const [showEndButton, setShowEndButton] = useState(false);

  const toggleEndEmulation = () => {
    setShowEndButton(!showEndButton);
  };

  return (
    <StyledContainer data-testid='container' showEndButton={showEndButton}>
      <Button
        data-testid='toggle-emulation-button'
        onClick={toggleEndEmulation}
        size='size300'
        css={currentlyEmulatingButtonStyles}
        after={
          showEndButton ? (
            <StyledIconSymbol
              icon='keyboard_arrow_up'
              color='white'
              size={16}
              data-testid='icon-symbol-up'
            />
          ) : (
            <StyledIconSymbol
              icon='keyboard_arrow_down'
              color='white'
              size={16}
              data-testid='icon-symbol-down'
            />
          )
        }
      >
        Currently Emulating
      </Button>
      {showEndButton && (
        <div style={{ height: 0 }}>
          <Button
            data-testid='end-emulation-button'
            onClick={onClick}
            variant='outline'
            size='size350'
            css={endEmualtionButtonStyles}
          >
            End Emulation
          </Button>
        </div>
      )}
    </StyledContainer>
  );
};

TechnicalUserButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
